import React, { useState, useEffect, useMemo } from "react";
import axios from "../config/axios";
import PageWrapper from "../components/common/PageWrapper";
import Header from "../components/common/Header";
import BodyWrapper from "../components/common/BodyWrapper";
import Footer from "../components/common/Footer";
import ScrollToTop from "../components/common/ScrollToTop";
import { useGeneral } from "../components/contexts/GeneralContext";
import ApiErrorMessage from "../components/common/ApiErrorMessage";
import NoItemsFound from "../components/common/NoItemsFound";
import FullScreenLoading from "../components/common/loading/FullScreenLoading";
import { cleanHTML, cleanHTML2 } from "../components/utils/commonHelper";
const usePageContent = () => {
  const [loading, setLoading] = useState(true);
  const [content, setContent] = useState([]);
  const [error, setError] = useState("");
  const { discountCoupons, setExtraContent } = useGeneral();

  useEffect(() => {
    let active = true;

    (async () => {
      try {
        const { data } = await axios.get("page-content/terms-conditions");
        if (active) setContent(data);
        setExtraContent((prev) => ({
          ...prev,
          socialChannels: data?.socialChannels,
          whatsAppNumber: data?.whatsAppNumber,
        }));
      } catch (err) {
        console.error(err);
        if (active) setError("Failed to load plans. Please try again later.");
      } finally {
        if (active) setLoading(false);
      }
    })();

    return () => {
      active = false;
    };
  }, []);

  return { content, loading, error, discountCoupons };
};

const useScrollToTop = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
    return () => clearTimeout(timer);
  }, []);
};
const TermsPage = () => {
  const { content, loading, error, discountCoupons } = usePageContent();
  useScrollToTop();
  const memoizedContent = useMemo(() => content, [content]);
  return (
    <>
      {loading && <FullScreenLoading />}
      <PageWrapper loading={true} className="bg-bg min-h-screen">
        <Header code={discountCoupons} />
        <BodyWrapper loading={loading} className="">
          {error ? (
            <ApiErrorMessage
              message1="Failed to load terms and conditions"
              message2="Please check your connection and try again."
            />
          ) : !loading && memoizedContent.length === 0 ? (
            <NoItemsFound
              message1="No content available"
              message2="Please check back later."
            />
          ) : (
            <>
              <div className="grid grid-cols-1 gap-8 items-start">
                <div>
                  <div className="bg-[#DEE2DD]/40 rounded-[15px] py-6 lg:py-12 relative flex items-center justify-center">
                    <div className="w-full px-6 md:px-12 xl:px-20 ">
                      <p className="text-34pt lg:text-36pt pb-4 lg:pb-4">
                        {memoizedContent.heading}
                      </p>
                      <div
                        className=" mb-6 terms-container text-green "
                        dangerouslySetInnerHTML={{
                          __html: cleanHTML2(memoizedContent?.content),
                        }}
                      />
                    </div>
                  </div>
                  
                </div>
              </div>
            </>
          )}
        </BodyWrapper>
        <Footer />
      </PageWrapper>
    </>
  );
};

export default TermsPage;
